const s = {
  page: { minHeight: '100vh', backgroundColor: '#f8f9fa', fontFamily: 'Inter, sans-serif', padding: '40px 20px' },
  card: { maxWidth: '800px', margin: '0 auto', backgroundColor: '#fff', borderRadius: '12px', boxShadow: '0 2px 16px rgba(0,0,0,0.08)', padding: '48px' },
  header: { textAlign: 'center' as const, marginBottom: '40px', borderBottom: '2px solid #FF6A3D', paddingBottom: '24px' },
  logo: { fontSize: '28px', fontWeight: 800, color: '#FF6A3D', marginBottom: '8px' },
  subtitle: { color: '#666', fontSize: '14px' },
  h2: { fontSize: '18px', fontWeight: 700, color: '#1a1a1a', marginTop: '32px', marginBottom: '12px' },
  p: { color: '#444', lineHeight: 1.7, fontSize: '15px', marginBottom: '12px' },
  ul: { color: '#444', lineHeight: 1.8, fontSize: '15px', paddingLeft: '20px', marginBottom: '12px' },
  footer: { marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #eee', textAlign: 'center' as const, color: '#999', fontSize: '13px' },
};

export const PrivacyClientPage = () => (
  <div style={s.page}>
    <div style={s.card}>
      <div style={s.header}>
        <div style={s.logo}>EncoreEats</div>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#1a1a1a', marginBottom: '6px' }}>Política de Privacidad</div>
        <div style={s.subtitle}>Aplicación para Clientes · Última actualización: 29 de abril de 2026</div>
      </div>

      <p style={s.p}>
        En <strong>EncoreEats</strong> nos comprometemos a proteger su privacidad. Esta política describe cómo recopilamos, usamos y protegemos su información personal cuando utiliza nuestra aplicación móvil para clientes.
      </p>

      <h2 style={s.h2}>1. Información que recopilamos</h2>
      <p style={s.p}>Recopilamos la siguiente información cuando usa nuestra aplicación:</p>
      <ul style={s.ul}>
        <li>Nombre completo, correo electrónico y número de teléfono (al registrarse)</li>
        <li>Dirección de entrega y ubicación geográfica</li>
        <li>Historial de pedidos y preferencias de pago</li>
        <li>Foto de perfil (opcional)</li>
        <li>Token de notificaciones push para enviarle alertas sobre sus pedidos</li>
        <li>Datos de uso de la aplicación (pantallas visitadas, búsquedas realizadas)</li>
      </ul>

      <h2 style={s.h2}>2. Permisos que utiliza la aplicación</h2>
      <ul style={s.ul}>
        <li><strong>Cámara:</strong> para tomar o seleccionar fotos de perfil</li>
        <li><strong>Ubicación:</strong> para detectar su dirección de entrega y rastrear su pedido en tiempo real</li>
        <li><strong>Notificaciones:</strong> para informarle sobre el estado de sus pedidos (confirmado, en camino, entregado)</li>
      </ul>

      <h2 style={s.h2}>3. Cómo usamos su información</h2>
      <ul style={s.ul}>
        <li>Procesar y gestionar sus pedidos de comida</li>
        <li>Coordinar la entrega con el restaurante y el repartidor</li>
        <li>Enviar notificaciones sobre el estado de su pedido</li>
        <li>Mejorar la experiencia del usuario en la aplicación</li>
        <li>Atender sus solicitudes de soporte</li>
      </ul>

      <h2 style={s.h2}>4. Servicios de terceros</h2>
      <p style={s.p}>Utilizamos los siguientes servicios de terceros que pueden tener acceso a su información:</p>
      <ul style={s.ul}>
        <li><strong>Firebase (Google):</strong> autenticación, base de datos y almacenamiento</li>
        <li><strong>Google Maps:</strong> visualización de mapas y rutas de entrega</li>
        <li><strong>Expo:</strong> infraestructura para notificaciones push</li>
      </ul>

      <h2 style={s.h2}>5. Retención de datos</h2>
      <p style={s.p}>
        Sus datos se conservan mientras mantenga una cuenta activa en EncoreEats. Puede solicitar la eliminación de su cuenta y datos personales en cualquier momento.
      </p>

      <h2 style={s.h2}>6. Seguridad</h2>
      <p style={s.p}>
        Implementamos medidas de seguridad técnicas y organizativas para proteger su información contra acceso no autorizado, pérdida o divulgación. Toda la comunicación entre la app y nuestros servidores se realiza mediante cifrado HTTPS.
      </p>

      <h2 style={s.h2}>7. Sus derechos</h2>
      <p style={s.p}>Usted tiene derecho a:</p>
      <ul style={s.ul}>
        <li>Acceder a sus datos personales</li>
        <li>Corregir información incorrecta</li>
        <li>Solicitar la eliminación de sus datos</li>
        <li>Retirar su consentimiento en cualquier momento</li>
      </ul>

      <h2 style={s.h2}>8. Contacto</h2>
      <p style={s.p}>
        Si tiene preguntas sobre esta política de privacidad o desea ejercer sus derechos, contáctenos en:<br />
        <strong>encoreeat@gmail.com</strong>
      </p>

      <div style={s.footer}>
        © 2026 EncoreEats. Todos los derechos reservados.
      </div>
    </div>
  </div>
);
